/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateShipperDto } from '../../models/create-shipper-dto';
import { ShipperCompany } from '../../models/shipper-company';

export interface CreateOneBaseMgmtShipperControllerShipperCompany$Params {
      body: CreateShipperDto
}

export function createOneBaseMgmtShipperControllerShipperCompany(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtShipperControllerShipperCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipperCompany>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtShipperControllerShipperCompany.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShipperCompany>;
    })
  );
}

createOneBaseMgmtShipperControllerShipperCompany.PATH = '/api/mgmt/shippers';
